define([
        './LocalDateChooser',
        'edge/platform/viewmodel/module',
        'edge/platform/widgets/datetimepicker/module',
        'edge/platform/time/module'],
    (localDateChooser) =>
        angular
            .module('edge.platform.widgets.ui.time', ['edge.platform.widgets.ui.bootstrap.datetimepicker', 'edge.platform.time'])
            .directive('gwPlLocalDateChooser', localDateChooser)
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/time/module.js
 **/